module.exports = __webpack_public_path__ + "static/img/flexiquoteloginbackground.a7bed929.jpg";